import styled, { css } from "styled-components";

export const mixins = {
  card: css`
    padding: 16px;
    border: 1px solid #eee;
  `,
  flexColumn: css`
    display: flex;
    flex-direction: column;
  `,
  flexRow: css`
    display: flex;
    flex-direction: row;
  `
};

export const FlexColumn = styled.div`${mixins.flexColumn}`;
export const FlexRow = styled.div`${mixins.flexRow}`;

export const ErrorMessage = styled.p`
  background-color: var(--danger-color);
  color: white;
  padding: 8px;
`;

export const FieldErrorMessage = styled.p`
  color: var(--danger-color);
`;
